// import { Delete } from "@mui/icons-material";
// import {
//   Grid,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   useTheme,
// } from "@mui/material";
// import axios from "axios";
// import _ from "lodash";
// import moment from "moment";
// import React, {
//   forwardRef,
//   memo,
//   useEffect,
//   useImperativeHandle,
//   useRef,
//   useState,
// } from "react";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { useStyle } from "../style";
// import Loader from "../../../../../components/loader/loader";

// const BillingTable = forwardRef((props, ref) => {
//   const classes = useStyle();
//   const outlet_id = localStorage.getItem("outlet_id");
//   const {data, setData, code, setCode, postData, setPostData, docName, poDetails, setCount, setSubCatName, } = props;
//   const [isLoader, setIsLoader] = useState(false); //loader
//   const dispatch = useDispatch();

//   const codeRef = useRef(null);

//   const handleCodeKeyPress = (e) => {
//     if (e.key === "Enter" && code !== "") {
//       getItemCode(code);
//     }
//   };

//   const handleDeleteRow = (e, i) => {
//     if (postData.salesman_id !== "") {
//       console.log(e, i);
//       const deleteData = {
//         barcode: e.barcode,
//         pro_id: e.prod_id,
//         pro_name: e.pro_name,
//         outlet_id: e.outlet_id,
//         sales_man_id: postData.salesman_id,
//         sales_man_name:
//           poDetails.salesManId != null && poDetails.salesManId.sales_man_name,
//         bill_no: docName,
//         mrp: e.mrp,
//         qty: e.qty,
//       };
//       console.log(deleteData);
//       axios
//         .post(`/v1/outlet_sales_screen_edit_log`, deleteData)
//         .then((res) => {
//           console.log(res);
//         })
//         .catch((err) => {
//           console.log(err);
//         });
//       const updateArr = [...data];
//       updateArr.splice(i, 1);
//       setData(updateArr);
//     } else {
//       dispatch(setSnackbar(true, "error", "Please select salesman"));
//     }

//     // axios.post(`/v1/outlet_sales_screen_edit_log`,deleteData)
//     // .then((res) => {console.log(res)})
//     // .catch((err) => {
//     //   console.log(err)
//     // })
//     // const updateArr = [...data]
//     // updateArr.splice(i,1)
//     // setData(updateArr)
//   };

//   const handleCodeChange = (e) => {
//     // setCode(e.target.value);
//     setCode(e.target.value.toUpperCase());
//   };

//   // const getItemCode = (id) => {
//   //   setIsLoader(true);
//   //   axios
//   //     .get(`/v1/itemdetails/barcode/${id}/${outlet_id}`)
//   //     .then((res) => {
//   //       console.log(res.data,"disssss");
//   //       setIsLoader(false);
//   //       getCount(res.data);
//   //       const objData = {
//   //         code: code,
//   //         barcode_to: id,
//   //         qty: 1,
//   //         mrp1: res.data.mrp,
//   //         pro_name: res.data.pro_name,
//   //         rate1: res.data.sale_rate,
//   //         gst1: res.data.gst,
//   //         disc1: res.data.special_discount,
//   //         gstAmt: res.data.special_discount === 100
//   //         ? 0
//   //         : parseFloat((res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) * (res.data.gst / 100)).toFixed(0),

//   //         // gstAmt: parseFloat(res.data.sale_rate * (res.data.gst / 100) * 1).toFixed(0),

//   //       cessAmt: parseFloat(
//   //         (res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) *
//   //         (res.data.cess / 100) *
//   //         1
//   //       ).toFixed(0),

//   //         cessAmt: parseFloat((res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) * (res.data.cess / 100) * 1).toFixed(0),
//   //         // totalAmt: parseFloat((res.data.sale_rate) * 1 ).toFixed(0),

//   //         totalAmt: res.data.special_discount === 100
//   //         ? 0
//   //         : parseFloat(
//   //             (res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) * 1
//   //           ).toFixed(0),
//   //         // totalAmt: parseFloat((res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) * 1 ).toFixed(0),
//   //         ...res.data,
//   //         // dis_amt :res.data.dis_amt,
//   //         discountamt: parseFloat(
//   //           (res.rate1 - (res.rate1 * (100 - res.disc1)) / 100) * res.qty
//   //         ).toFixed(0),
//   //       };
//   //       const existingItemIndex = data.findIndex(
//   //         (item) =>
//   //           item.code === objData.code &&
//   //           (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1)
//   //       );
//   //       const arr = [...data];
//   //       setData([]);
//   //       if (existingItemIndex !== -1) {
//   //         dispatch(setSnackbar(true, "error", "Barcode already exists!"));
//   //         setData(arr);
//   //       } else {
//   //         arr.push(objData);
//   //         setData(arr);
//   //         setCode("");
//   //       }
//   //       codeRef.current.focus();
//   //     })
//   //     .catch((err) => {
//   //       setIsLoader(false);
//   //       setData([]);
//   //       setCode("");
//   //       console.log(err.response.data.errors[0].message);
//   //       dispatch(
//   //         setSnackbar(true, "error", err.response.data.errors[0].message || "data not found")
//   //       );

//   //     });
//   // };

//   const getItemCode = (id) => {
//     setIsLoader(true);
//     axios
//       .get(`/v1/itemdetails/barcode/${id}/${outlet_id}`)
//       .then((res) => {
//         console.log(res.data, "disssss");
//         setIsLoader(false);
//         getCount(res.data);

//         const objData = {
//           code: code,
//           barcode_to: id,
//           qty: 1,
//           mrp1: res.data.mrp,
//           pro_name: res.data.pro_name,
//           rate1: res.data.sale_rate,
//           gst1: res.data.gst,
//           disc1: res.data.special_discount,
//           gstAmt:
//             res.data.special_discount === 100
//               ? 0
//               : parseFloat(
//                   (res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) *
//                     (res.data.gst / 100)
//                 ).toFixed(2),
//           cessAmt: parseFloat(
//             (res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) *
//               (res.data.cess / 100)
//           ).toFixed(0),
//           totalAmt:
//             res.data.special_discount === 100
//               ? 0
//               : parseFloat(
//                   (res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) * 1
//                 ).toFixed(2),
//           ...res.data,
//           discountamt: parseFloat(
//             (res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) * 1
//           ).toFixed(0),
//         };

//         const existingItemIndex = data.findIndex(
//           (item) =>
//             item.code === objData.code &&
//             (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1)
//         );

//         if (existingItemIndex !== -1) {
//           dispatch(setSnackbar(true, "error", "Barcode already exists!"));
//         } else {
//           setData((prevData) => [...prevData, objData]); // Keep existing data and add new item
//           setCode("");
//         }

//         codeRef.current.focus();
//       })
//       .catch((err) => {
//         setIsLoader(false);
//         setCode("");

//         console.log(err.response?.data?.errors?.[0]?.message || "Error occurred");

//         dispatch(
//           setSnackbar(
//             true,
//             "error",
//             err.response?.data?.errors?.[0]?.message || "Data not found"
//           )
//         );
//       });
//   };

//   function getCount(isData) {
//     const catSubData = {
//       cat_id: isData.cat_id,
//       sub_cat_id: isData.sub_cat,
//       outlet_id: outlet_id,
//     };
//     axios
//       .post(`/v1/outlet/available_stock_count`, catSubData)
//       // .post(`/v1/outlet/closing_stock_count`, catSubData)
//       .then((res) => {
//         console.log(res);
//         setCount(res.data.total);
//         setSubCatName(res.data.sub_category_name);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }
//   const clearNew = () => {
//     setCode("");
//     codeRef.current.focus();
//   };

//   useImperativeHandle(ref, () => ({
//     focusCodeInput: () => {
//       codeRef.current.focus();
//     },
//   }));

//   useEffect(() => {
//     if (data.length > 0) {
//       let arr = [];
//       data.map((val) => {
//         const obj = {
//           docdate: moment().format("YYYY/MM/DD"),
//           prodid: val.id,
//           dis_per: val.disc1,
//           dis_amt: parseFloat(
//             (val.mrp - (val.mrp * (100 - val.disc1)) / 100) * val.qty
//           ).toFixed(0),
//           // dis_amt: parseFloat(
//           //   (val.rate1 - (val.rate1 * (100 - val.disc1)) / 100) * val.qty
//           // ).toFixed(0),
//           mrp: val.mrp1,
//           rate: val.rate1,
//           qty: val.qty,
//           gst_per: val.gst1,
//           gst_amt: val.gstAmt,
//           cess_per: val.cess,
//           cess_amt: val.cessAmt,
//           company_id: 1,
//           barcode: val.barcode,
//           head_id: val.head_id,
//           type_id: val.type,
//           subcat_id: val.sub_cat,
//           cat_id: val.cat_id,
//           uom_id: val.uom,
//           outletid: outlet_id,
//         };
//         arr.push(obj);
//       });
//       setPostData((prevState) => ({ ...prevState, outlet_sales_details: arr }));
//     }
//   }, [data]);
//   return (
//     <Grid className="w-full " sx={{ height: "350px", overflow: "auto" }}>
//       <TableContainer className={classes.tblRoot}>
//         <Table stickyHeader className={classes.table}>
//           <TableHead className={classes.tblHeader}>
//             <TableRow className={classes.tablrow}>
//               <TableCell className={classes.tblCell} sx={{ borderLeft: "0.5px solid  #ccc" }}>Sno</TableCell>
//               <TableCell className={classes.tblCell} sx={{ minWidth: "150px" }}>Barcode</TableCell>
//               <TableCell className={classes.tblCell} sx={{ minWidth: "150px" }}>Product Name</TableCell>
//               <TableCell className={classes.tblCell}>MRP</TableCell>
//               <TableCell className={classes.tblCell}>GST%</TableCell>
//               <TableCell className={classes.tblCell}>Rate</TableCell>
//               <TableCell className={classes.tblCell}>Dis%</TableCell>
//               <TableCell className={classes.tblCell}>Qty</TableCell>
//               <TableCell className={classes.tblCell}>GST</TableCell>
//               <TableCell className={classes.tblCell}>Amount</TableCell>
//               <TableCell className={classes.tblCell}>Action</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {_.map(data, (val, idx) => (
//               <TableRow className={classes.tablrow} key={idx}>
//                 <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ borderLeft: "0.5px solid  #ccc" }}>{idx + 1}</TableCell>
//                 <TableCell>{val.code}</TableCell>
//                 <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
//                 <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}>{Math.round(val.mrp1)}</TableCell>
//                 <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}>{Math.round(val.gst1)}</TableCell>
//                 <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}>{val.rate1}</TableCell>
//                 {/* <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}>{val.disc1}</TableCell> */}
//                 <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}>{parseFloat(val.disc1).toFixed(0)} %</TableCell>

//                 <TableCell>{val.qty}</TableCell>
//                 <TableCell className={classes.tblContentCell} sx={{ width: 100 }}>{parseFloat(val.gstAmt).toFixed(2)}</TableCell>
//                 <TableCell className={classes.tblContentCell} sx={{ width: 100 }}>{parseFloat(val.totalAmt).toFixed(2)}</TableCell>
//                 <TableCell className={classes.tblContentCell} sx={{ width: 100 }}>
//                   <IconButton onClick={() => handleDeleteRow(val, idx)}><Delete sx={{ color: "red", fontSize: 18 }} /></IconButton>
//                 </TableCell>
//               </TableRow>
//             ))}
//             <TableRow className={classes.tablrow}
//               ref={(ref) => {
//                 if (codeRef.current) {
//                   ref?.scrollIntoView({ behavior: "smooth", block: "center" });
//                 }
//               }}
//             >
//               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ borderLeft: "0.5px solid  #ccc" }}>{data.length + 1}</TableCell>
//               <TableCell padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}>
//                 <TextField inputRef={codeRef} size="small" value={code}
//                  onChange={handleCodeChange}
//                  onKeyPress={handleCodeKeyPress}/>
//               </TableCell>
//               <TableCell variant="body" className={classes.tblContentCell} />
//               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}/>
//               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}/>
//               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}/>
//               <TableCell padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}/>
//               <TableCell className={classes.tblContentCell} sx={{ width: 100 }}/>
//               <TableCell className={classes.tblContentCell} sx={{ width: 100 }}/>
//               <TableCell className={classes.tblContentCell} sx={{ width: 100 }}/>
//               <TableCell className={classes.tblContentCell} sx={{ width: 100 }}>
//                 <IconButton onClick={clearNew}><Delete sx={{ color: "red", fontSize: 18 }} /></IconButton>
//               </TableCell>
//             </TableRow>
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <Loader isLoader={isLoader} />
//     </Grid>
//   );
// });

// export default memo(BillingTable);
//testing referral program
import { Delete } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useTheme,
} from "@mui/material";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useStyle } from "../style";
import Loader from "../../../../../components/loader/loader";

const BillingTable = forwardRef((props, ref) => {
  const classes = useStyle();
  const outlet_id = localStorage.getItem("outlet_id");
  const {
    data,
    setData,
    code,
    setCode,
    postData,
    setPostData,
    docName,
    poDetails,
    setCount,
    setSubCatName,
  } = props;
  const [isLoader, setIsLoader] = useState(false); //loader
  const dispatch = useDispatch();

  const codeRef = useRef(null);
  const { onPendingDeleted } = props;
  const { setCurrentTempId } = props;

  const handleCodeKeyPress = (e) => {
    if (e.key === "Enter" && code !== "") {
      getItemCode(code);
    }
  };

  // const handleDeleteRow = async (e, i) => {
  //   if (postData.salesman_id !== "") {
  //     console.log(e, i);
  //     const deleteData = {
  //       barcode: e.barcode,
  //       pro_id: e.prod_id,
  //       pro_name: e.pro_name,
  //       outlet_id: e.outlet_id,
  //       sales_man_id: postData.salesman_id,
  //       sales_man_name:
  //         poDetails.salesManId != null && poDetails.salesManId.sales_man_name,
  //       bill_no: docName,
  //       mrp: e.mrp,
  //       qty: e.qty,
  //     };
  //     console.log(deleteData);
  //     axios
  //       .post(`/v1/outlet_sales_screen_edit_log`, deleteData)
  //       .then((res) => {
  //         console.log(res);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //     if (postData.outlet_sales_temp_id) {
  //       try {
  //         await axios.delete(
  //           `/v1/outlet_sales_pending_bill/1/${outlet_id}/${postData.outlet_sales_temp_id}`
  //         );
  //         onPendingDeleted?.(postData.outlet_sales_temp_id);
  //         dispatch(setSnackbar(true, "success", "Pending bill deleted!"));
  //         setPostData((prev) => ({
  //           ...prev,
  //           outlet_sales_temp_id: null,
  //         }));
  //         setData([]);
  //         props.setCurrentTempId?.(null);
  //         console.log("Pending bill deleted:", postData.outlet_sales_temp_id);
  //       } catch (err) {
  //         dispatch(setSnackbar(true, "error", "Pending bill delete failed"));
  //         console.log("Pending delete error:", err);
  //       }
  //     }

  //     const updateArr = [...data];
  //     updateArr.splice(i, 1);
  //     setData(updateArr);
  //   } else {
  //     dispatch(setSnackbar(true, "error", "Please select salesman"));
  //   }

  //   // axios.post(`/v1/outlet_sales_screen_edit_log`,deleteData)
  //   // .then((res) => {console.log(res)})
  //   // .catch((err) => {
  //   //   console.log(err)
  //   // })
  //   // const updateArr = [...data]
  //   // updateArr.splice(i,1)
  //   // setData(updateArr)
  // };
  const handleDeleteRow = async (e, i) => {
    if (postData.salesman_id !== "") {
      console.log(e, i);

      const deleteData = {
        barcode: e.barcode,
        pro_id: e.prod_id,
        pro_name: e.pro_name,
        outlet_id: e.outlet_id,
        sales_man_id: postData.salesman_id,
        sales_man_name:
          poDetails.salesManId != null && poDetails.salesManId.sales_man_name,
        bill_no: docName,
        mrp: e.mrp,
        qty: e.qty,
      };
      console.log(deleteData);
      axios
        .post(`/v1/outlet_sales_screen_edit_log`, deleteData)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });

      if (postData.outlet_sales_temp_id && e.id) {
        try {
          await axios.delete(
            `/v1/outlet_sales_pending_bill/product/1/${outlet_id}/${postData.outlet_sales_temp_id}/${e.id}`
          );
          dispatch(
            setSnackbar(true, "success", "Product deleted successfully")
          );
          console.log("Pending bill product deleted:", e.id);
        } catch (err) {
          console.log("Pending bill product delete error:", err);
          dispatch(
            setSnackbar(
              true,
              "error",
              "Product delete from pending bill failed"
            )
          );
          return;
        }
      }
      const updateArr = [...data];
      updateArr.splice(i, 1);
      setData(updateArr);
    } else {
      dispatch(setSnackbar(true, "error", "Please select salesman"));
    }
  };

  const handleCodeChange = (e) => {
    // setCode(e.target.value);
    setCode(e.target.value.toUpperCase());
  };

  // const getItemCode = (id) => {
  //   setIsLoader(true);
  //   axios
  //     .get(`/v1/itemdetails/barcode/${id}/${outlet_id}`)
  //     .then((res) => {
  //       console.log(res.data,"disssss");
  //       setIsLoader(false);
  //       getCount(res.data);
  //       const objData = {
  //         code: code,
  //         barcode_to: id,
  //         qty: 1,
  //         mrp1: res.data.mrp,
  //         pro_name: res.data.pro_name,
  //         rate1: res.data.sale_rate,
  //         gst1: res.data.gst,
  //         disc1: res.data.special_discount,
  //         gstAmt: res.data.special_discount === 100
  //         ? 0
  //         : parseFloat((res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) * (res.data.gst / 100)).toFixed(0),

  //         // gstAmt: parseFloat(res.data.sale_rate * (res.data.gst / 100) * 1).toFixed(0),

  //       cessAmt: parseFloat(
  //         (res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) *
  //         (res.data.cess / 100) *
  //         1
  //       ).toFixed(0),

  //         cessAmt: parseFloat((res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) * (res.data.cess / 100) * 1).toFixed(0),
  //         // totalAmt: parseFloat((res.data.sale_rate) * 1 ).toFixed(0),

  //         totalAmt: res.data.special_discount === 100
  //         ? 0
  //         : parseFloat(
  //             (res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) * 1
  //           ).toFixed(0),
  //         // totalAmt: parseFloat((res.data.sale_rate - (res.data.sale_rate * res.data.special_discount) / 100) * 1 ).toFixed(0),
  //         ...res.data,
  //         // dis_amt :res.data.dis_amt,
  //         discountamt: parseFloat(
  //           (res.rate1 - (res.rate1 * (100 - res.disc1)) / 100) * res.qty
  //         ).toFixed(0),
  //       };
  //       const existingItemIndex = data.findIndex(
  //         (item) =>
  //           item.code === objData.code &&
  //           (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1)
  //       );
  //       const arr = [...data];
  //       setData([]);
  //       if (existingItemIndex !== -1) {
  //         dispatch(setSnackbar(true, "error", "Barcode already exists!"));
  //         setData(arr);
  //       } else {
  //         arr.push(objData);
  //         setData(arr);
  //         setCode("");
  //       }
  //       codeRef.current.focus();
  //     })
  //     .catch((err) => {
  //       setIsLoader(false);
  //       setData([]);
  //       setCode("");
  //       console.log(err.response.data.errors[0].message);
  //       dispatch(
  //         setSnackbar(true, "error", err.response.data.errors[0].message || "data not found")
  //       );

  //     });
  // };

  const getItemCode = (id) => {
    setIsLoader(true);
    axios
      .get(`/v1/itemdetails/barcode/${id}/${outlet_id}`)
      .then((res) => {
        console.log(res.data, "disssss");
        setIsLoader(false);
        getCount(res.data);

        const objData = {
          code: code,
          barcode_to: id,
          qty: 1,
          mrp1: res.data.mrp,
          pro_name: res.data.pro_name,
          rate1: res.data.sale_rate,
          gst1: res.data.gst,
          disc1: res.data.special_discount,
          gstAmt:
            res.data.special_discount === 100
              ? 0
              : parseFloat(
                  (res.data.sale_rate -
                    (res.data.sale_rate * res.data.special_discount) / 100) *
                    (res.data.gst / 100)
                ).toFixed(2),
          cessAmt: parseFloat(
            (res.data.sale_rate -
              (res.data.sale_rate * res.data.special_discount) / 100) *
              (res.data.cess / 100)
          ).toFixed(0),
          totalAmt:
            res.data.special_discount === 100
              ? 0
              : parseFloat(
                  (res.data.sale_rate -
                    (res.data.sale_rate * res.data.special_discount) / 100) *
                    1
                ).toFixed(2),
          ...res.data,
          discountamt: parseFloat(
            (res.data.sale_rate -
              (res.data.sale_rate * res.data.special_discount) / 100) *
              1
          ).toFixed(0),
        };

        // const existingItemIndex = data.findIndex(
        //   (item) =>
        //     item.code === objData.code &&
        //     (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1)
        // );
        // 19-01-26
        const existingItemIndex = data.findIndex(
          (item) => item.code === id || item.barcode === id
        );

        if (existingItemIndex !== -1) {
          dispatch(setSnackbar(true, "error", "Barcode already exists!"));
        } else {
          setData((prevData) => [...prevData, objData]); // Keep existing data and add new item
          setCode("");
        }

        codeRef.current.focus();
      })
      .catch((err) => {
        setIsLoader(false);
        setCode("");

        console.log(
          err.response?.data?.errors?.[0]?.message || "Error occurred"
        );

        dispatch(
          setSnackbar(
            true,
            "error",
            err.response?.data?.errors?.[0]?.message || "Data not found"
          )
        );
      });
  };

  function getCount(isData) {
    const catSubData = {
      cat_id: isData.cat_id,
      sub_cat_id: isData.sub_cat,
      outlet_id: outlet_id,
    };
    axios
      .post(`/v1/outlet/available_stock_count`, catSubData)
      // .post(`/v1/outlet/closing_stock_count`, catSubData)
      .then((res) => {
        console.log(res);
        setCount(res.data.total);
        setSubCatName(res.data.sub_category_name);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  const clearNew = () => {
    setCode("");
    codeRef.current.focus();
  };

  useImperativeHandle(ref, () => ({
    focusCodeInput: () => {
      codeRef.current.focus();
    },
  }));

  useEffect(() => {
    if (data.length > 0) {
      let arr = [];
      data.map((val) => {
        const obj = {
          docdate: moment().format("YYYY/MM/DD"),
          prodid: val.id,
          dis_per: val.disc1,
          dis_amt: parseFloat(
            (val.mrp - (val.mrp * (100 - val.disc1)) / 100) * val.qty
          ).toFixed(0),
          // dis_amt: parseFloat(
          //   (val.rate1 - (val.rate1 * (100 - val.disc1)) / 100) * val.qty
          // ).toFixed(0),
          mrp: val.mrp1,
          rate: val.rate1,
          qty: val.qty,
          gst_per: val.gst1,
          gst_amt: val.gstAmt,
          cess_per: val.cess,
          cess_amt: val.cessAmt,
          company_id: 1,
          barcode: val.barcode,
          head_id: val.head_id,
          type_id: val.type,
          subcat_id: val.sub_cat,
          cat_id: val.cat_id,
          uom_id: val.uom,
          outletid: outlet_id,
        };
        arr.push(obj);
      });
      setPostData((prevState) => ({ ...prevState, outlet_sales_details: arr }));
    }
  }, [data]);
  return (
    <Grid className="w-full " sx={{ height: "350px", overflow: "auto" }}>
      <TableContainer className={classes.tblRoot}>
        <Table stickyHeader className={classes.table}>
          <TableHead className={classes.tblHeader}>
            <TableRow className={classes.tablrow}>
              <TableCell
                className={classes.tblCell}
                sx={{ borderLeft: "0.5px solid  #ccc" }}
              >
                Sno
              </TableCell>
              <TableCell className={classes.tblCell} sx={{ minWidth: "150px" }}>
                Barcode
              </TableCell>
              <TableCell className={classes.tblCell} sx={{ minWidth: "150px" }}>
                Product Name
              </TableCell>
              <TableCell className={classes.tblCell}>MRP</TableCell>
              <TableCell className={classes.tblCell}>GST%</TableCell>
              <TableCell className={classes.tblCell}>Rate</TableCell>
              <TableCell className={classes.tblCell}>Dis%</TableCell>
              <TableCell className={classes.tblCell}>Qty</TableCell>
              <TableCell className={classes.tblCell}>GST</TableCell>
              <TableCell className={classes.tblCell}>Amount</TableCell>
              <TableCell className={classes.tblCell}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {_.map(data, (val, idx) => (
              <TableRow className={classes.tablrow} key={idx}>
                <TableCell
                  padding="checkbox"
                  className={classes.tblContentCell}
                  sx={{ borderLeft: "0.5px solid  #ccc" }}
                >
                  {idx + 1}
                </TableCell>
                <TableCell>{val.code}</TableCell>
                <TableCell variant="body" className={classes.tblContentCell}>
                  {val.pro_name}
                </TableCell>
                <TableCell
                  padding="checkbox"
                  className={classes.tblContentCell}
                  sx={{ width: 100 }}
                >
                  {Math.round(val.mrp1)}
                </TableCell>
                <TableCell
                  padding="checkbox"
                  className={classes.tblContentCell}
                  sx={{ width: 100 }}
                >
                  {Math.round(val.gst1)}
                </TableCell>
                <TableCell
                  padding="checkbox"
                  className={classes.tblContentCell}
                  sx={{ width: 100 }}
                >
                  {val.rate1}
                </TableCell>
                {/* <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}>{val.disc1}</TableCell> */}
                <TableCell
                  padding="checkbox"
                  className={classes.tblContentCell}
                  sx={{ width: 100 }}
                >
                  {parseFloat(val.disc1).toFixed(0)} %
                </TableCell>

                <TableCell>{val.qty}</TableCell>
                <TableCell
                  className={classes.tblContentCell}
                  sx={{ width: 100 }}
                >
                  {parseFloat(val.gstAmt).toFixed(2)}
                </TableCell>
                <TableCell
                  className={classes.tblContentCell}
                  sx={{ width: 100 }}
                >
                  {parseFloat(val.totalAmt).toFixed(2)}
                </TableCell>
                <TableCell
                  className={classes.tblContentCell}
                  sx={{ width: 100 }}
                >
                  <IconButton onClick={() => handleDeleteRow(val, idx)}>
                    <Delete sx={{ color: "red", fontSize: 18 }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow
              className={classes.tablrow}
              ref={(ref) => {
                if (codeRef.current) {
                  ref?.scrollIntoView({ behavior: "smooth", block: "center" });
                }
              }}
            >
              <TableCell
                padding="checkbox"
                className={classes.tblContentCell}
                sx={{ borderLeft: "0.5px solid  #ccc" }}
              >
                {data.length + 1}
              </TableCell>
              <TableCell
                padding="checkbox"
                sx={{ width: 120 }}
                className={classes.tblContentCell}
              >
                <TextField
                  inputRef={codeRef}
                  size="small"
                  value={code}
                  onChange={handleCodeChange}
                  onKeyPress={handleCodeKeyPress}
                />
              </TableCell>
              <TableCell variant="body" className={classes.tblContentCell} />
              <TableCell
                padding="checkbox"
                className={classes.tblContentCell}
                sx={{ width: 100 }}
              />
              <TableCell
                padding="checkbox"
                className={classes.tblContentCell}
                sx={{ width: 100 }}
              />
              <TableCell
                padding="checkbox"
                className={classes.tblContentCell}
                sx={{ width: 100 }}
              />
              <TableCell
                padding="checkbox"
                sx={{ width: 120 }}
                className={classes.tblContentCell}
              />
              <TableCell
                className={classes.tblContentCell}
                sx={{ width: 100 }}
              />
              <TableCell
                className={classes.tblContentCell}
                sx={{ width: 100 }}
              />
              <TableCell
                className={classes.tblContentCell}
                sx={{ width: 100 }}
              />
              <TableCell className={classes.tblContentCell} sx={{ width: 100 }}>
                <IconButton onClick={clearNew}>
                  <Delete sx={{ color: "red", fontSize: 18 }} />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Loader isLoader={isLoader} />
    </Grid>
  );
});

export default memo(BillingTable);
